import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { type ApprovedExpenseItemApiModel } from '../api-models/ApprovedExpenseItemApiModel'
import { ApprovedExpenseItemApiModelStub } from '../api-models/stubs/ApprovedExpenseItemApiModel.stub'

export const mockListApprovedExpenseItemsSuccess = (
  data: ApprovedExpenseItemApiModel[] = ApprovedExpenseItemApiModelStub.buildList(
    1
  ),
  pagination = {}
) => {
  return rest.get('/api/v3/expenses/items/approved/', (_, res, ctx) => {
    return res.once(
      ctx.status(200),
      ctx.json(getResponseObject(data, pagination))
    )
  })
}
